import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy = () => (
  <Container maxWidth="md" sx={{ py: 6 }}>
    <Typography variant="h4" gutterBottom>Privacy Policy</Typography>
    <Box sx={{ color: 'text.secondary', mt: 2 }}>
      <Typography paragraph>
        Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our services.
      </Typography>
      <Typography variant="h6" gutterBottom>Information We Collect</Typography>
      <Typography paragraph>
        We may collect personal information such as your name, email address, and usage data when you use our app.
      </Typography>
      <Typography variant="h6" gutterBottom>How We Use Information</Typography>
      <Typography paragraph>
        We use your information to provide, maintain, and improve our services, and to communicate with you about updates or offers.
      </Typography>
      <Typography variant="h6" gutterBottom>Information Sharing</Typography>
      <Typography paragraph>
        We do not share your personal information with third parties except as required by law or to provide our services.
      </Typography>
      <Typography variant="h6" gutterBottom>Security</Typography>
      <Typography paragraph>
        We take reasonable measures to protect your information from unauthorized access or disclosure.
      </Typography>
      <Typography variant="h6" gutterBottom>Contact Us</Typography>
      <Typography paragraph>
        If you have any questions about this Privacy Policy, please contact us at hello@finextra.app.
      </Typography>
    </Box>
  </Container>
);

export default PrivacyPolicy; 